import { render, staticRenderFns } from "./DataExportWidget.vue?vue&type=template&id=39bb2eae&scoped=true&"
import script from "./DataExportWidget.vue?vue&type=script&lang=js&"
export * from "./DataExportWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb2eae",
  null
  
)

export default component.exports